import { render, staticRenderFns } from "./SystemDashboard.vue?vue&type=template&id=4ba7dd29"
import script from "./SystemDashboard.vue?vue&type=script&lang=ts"
export * from "./SystemDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports